// React component to show a preview of the bill from data
import React from 'react';
import { LoadLocation } from '../../../redux/api/load/load.model';
import StringUtils from '../../../utils/stringUtils';

export interface BillFromPreviewProps {
  name?: string;
  location?: LoadLocation;
  billingEmail?: string;
  phone?: string;
}

const BillFromPreview: React.FC<BillFromPreviewProps> = ({
  name,
  location,
  billingEmail,
  phone
}): JSX.Element => {
  return (
    <>
      {name && <span className="create-invoice__bill-name">{name}</span>}
      {location && <span className="create-invoice__bill-description">{location.address_1}</span>}
      {location && location.address_2 && (
        <span className="create-invoice__bill-description">{location.address_2}</span>
      )}
      {billingEmail && <span className="create-invoice__bill-description">{billingEmail}</span>}
      <span className="create-invoice__bill-description">
        {phone && StringUtils.formatPhoneNumber(phone)}
      </span>
    </>
  );
};

export default BillFromPreview;
